

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var Main = function( )
	{
		var _this = this , i ;

		/*=================================
		Aboutpage background
		=================================*/
		var _elm = $("#spin-anime-bg li");


		//配列をシャッフル
		function shuffle(a){
			var i = a.length;
			while(i){
				var j = Math.floor(Math.random()*i);
				var t = a[--i];
				a[i] = a[j];
				a[j] = t;
			}
			return a;
		}

		function spinClass(){
			var spinClass = [ "is-spin01","is-spin02","is-spin03","is-spin04","is-spin05","is-spin06","is-spin07","is-spin08","is-spin09","is-spin10","is-spin11"];
			clsCnt = spinClass.length;
			shuffle(spinClass);
			itmp = 0;

			_elm.each(function(i, val) {
				$(this).addClass(spinClass[itmp]);

				if (itmp < clsCnt-1) {
					itmp++;
				}else{
					itmp = 0;
					shuffle(spinClass);
				}
			});
		}

		function sizeClass(){
			var sizeClass = [ "is-size01","is-size02","is-size03","is-size04","is-size05","is-size06","is-size07","is-size08","is-size09","is-size10","is-size11"];
			clsCnt = sizeClass.length;
			shuffle(sizeClass);
			itmp = 0;

			_elm.each(function(i, val) {
				$(this).addClass(sizeClass[itmp]);

				if (itmp < clsCnt-1) {
					itmp++;
				}else{
					itmp = 0;
					shuffle(sizeClass);
				}
			});
		}

		function moveClass(){
			var moveClass = [ "move-01","move-02","move-03","move-04","move-05","move-06","move-07","move-08","move-09","move-10","move-11"];
			clsCnt = moveClass.length;
			shuffle(moveClass);
			itmp = 0;

			_elm.each(function(i, val) {
				$(this).addClass(moveClass[itmp]);

				if (itmp < clsCnt-1) {
					itmp++;
				}else{
					itmp = 0;
					shuffle(moveClass);
				}
			});
		}

		$(window).on('load',function(){
			fall();
		});

		var spinClasses = [ "is-spin01","is-spin02","is-spin03","is-spin04","is-spin05","is-spin06","is-spin07","is-spin08","is-spin09","is-spin10","is-spin11"];
		var sizeClasses = [ "is-size01","is-size02","is-size03","is-size04","is-size05","is-size06","is-size07","is-size08","is-size09","is-size10","is-size11"];
		var imageClasses = [ "img-spin-01","img-spin-02","img-spin-03","img-spin-04","img-spin-05","img-spin-06","img-spin-07","img-spin-08","img-spin-09","img-spin-10","img-spin-11"];

		spinClasses = _.shuffle(spinClasses);
		sizeClasses = _.shuffle(sizeClasses);
		imageClasses = _.shuffle(imageClasses);
		var target = $("#spin-anime-bg li");


		var fall = function(){

			var _num;
			if($('html').hasClass('width-sp' || 'is__SP')){
				_num = 800;
			}else if($('html').hasClass('is_Tab')){
				_num = 800;
			}else{
				_num = 1200;
			}
			var _this = this,i;
			var delay = 0;
			for( i = 0 ; i < target.length ; i++ )
			{
				var classes = 'spin' + ' ' + spinClasses[i] + ' ' + sizeClasses[i] +  ' ' + imageClasses[i];
				target[i].className = classes;

				$(target[i]).delay((delay+800*i)).animate({top: _num,},_.random(4000,6000),callback);
			}

			spinClasses = _.shuffle(spinClasses);
			sizeClasses = _.shuffle(sizeClasses);
			imageClasses = _.shuffle(imageClasses);

			var count = 0;
			function callback(){
				var classes = 'spin' + ' ' + spinClasses[count] + ' ' + sizeClasses[count] + ' ' + imageClasses[count];
				this.className = classes;
				this.style.top = "-300px";
				$(this).animate({top: _num,},_.random(5000,9000),callback);
				count++;
				if(count >= 11){
					count = 0;
					spinClasses = _.shuffle(spinClasses);
					sizeClasses = _.shuffle(sizeClasses);
					// imageClasses = _.shuffle(imageClasses);
				}
			}

		}

		//	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-	-

		// リサイズイベントを使うときは、この_onResize内に処理を書いてください。
		// リサイズイベントを綱わないようでしたら決してください。
		// var _onResize = function( )
		// {
		// }

		// _onResize( ) ;
		// FitContents.addTask( _onResize ) ;
	}

	var AboutStage = function( ){
		console.log('AboutStage');
		var _this = this , i ;
		var _root = AboutStage.root = document.getElementById( "canvas" );
		var _renderer = AboutStage.renderer = PIXI.autoDetectRenderer( _root.clientWidth , _root.clientHeight , { transparent:true } ) ;
		var _stage = AboutStage.stage = new PIXI.Container( ) ;

		AboutStage.Settings = {
			StartSize : {
				x : _root.clientWidth,
				y : _root.clientHeight,
				ratio: _root.clientWidth/_root.clientHeight
			},
			scale : {
				pc: 1,
				sp: 0.2
			},
			mode : (Fit.mode == 'sp')? 'sp' : 'pc',
			setScale: ''
		};



		AboutStage.Settings.setScale = AboutStage.Settings.scale[AboutStage.Settings.mode];
		var _fallAnimation =  new AboutStage.fallAnimation( ) ;

		_stage.addChild( _fallAnimation.root ) ;

		_root.appendChild(_renderer.view);
		_renderer.view.style.position = 'absolute';
		_renderer.view.style.top = 0;

		AboutStage.fallAnimation.run();
		var _update = function( )
		{
			window.requestAnimationFrame( _update ) ;

			_renderer.render( _stage ) ;
		}
		window.requestAnimationFrame( _update ) ;


		var _onResize = function( )
		{	//リサイズ処理
			AboutStage.renderer.view.style.width = AboutStage.root.clientWidth + "px";
			AboutStage.renderer.view.style.height = AboutStage.root.clientHeight + "px";

			console.log(AboutStage.Settings.StartSize.ratio,AboutStage.root.clientWidth/AboutStage.root.clientHeight);

			var mode = (Fit.mode == 'sp')? 'sp' : 'pc';
			AboutStage.Settings.setScale = AboutStage.Settings.scale[mode];
		}
		$(window).on('resize',_onResize);
	}

	AboutStage.fallAnimation = function( )
	{
		var _this = this , i ;
		var _root = _this.root = new PIXI.Container( ) ;
		var _icon = [ ] ;
		var _iconNumber = [ ] ;

		for( i = 0 ; i < 12 ; i++ )
		{
			var temp = new PIXI.Sprite( PIXI.Texture.fromCanvas( AboutStage.img.icon[i%10] ) ) ;
			temp.vec = { x:0 , y:0 , rotation:0 } ;
			_icon.push( temp ) ;

			_iconNumber.push( i ) ;
		}
		_iconNumber = _.shuffle(_iconNumber);

		var count = AboutStage.fallAnimation.count = 0;

		var _onUpdate = function(count)
		{
			_onUpdate.id = window.requestAnimationFrame( _onUpdate ) ;
			for( i = 0 ; i < _icon.length ; i++ )
			{
				var temp = _icon[i] ;

				// temp.x += temp.vec.x ;
				temp.y += temp.vec.y ;


				if( temp.y > AboutStage.renderer.height + 100 )
				{
					temp.y = -AboutStage.renderer.height - 100 ;
					temp.x = AboutStage.renderer.width - (AboutStage.renderer.width / 12 * _iconNumber[AboutStage.fallAnimation.count]);
					AboutStage.fallAnimation.count++;

					if( AboutStage.fallAnimation.count > 11 )
					{
						AboutStage.fallAnimation.count = 0;
						_iconNumber = _.shuffle(_iconNumber);
					}
				}

				temp.rotation -= temp.vec.rotation ;

				temp.anchor.x = temp.anchor.y = 0.5 ;

				_root.addChild( temp ) ;
			}

		}
		_onUpdate.id = null ;
		AboutStage.fallAnimation.run = function( )
		{
			_root.alpha = 1;
			_root.visible = true;
			for( i = 0 ; i < _icon.length ; i++ )
			{
				var temp = _icon[i] ;

				temp.x = AboutStage.renderer.width - (AboutStage.renderer.width / 12 *_iconNumber[i]) ;
				temp.y = -AboutStage.renderer.height - ( AboutStage.renderer.height * Math.random( ) ) - 10 ;

				temp.scale.x = temp.scale.y = 0.1 + Math.random() * 0.2 * AboutStage.Settings.setScale;
				console.log(AboutStage.Settings.setScale);

				temp.vec.y = Math.random()*3 + 2.5 ;
				temp.vec.rotation = 0.03 + 0.01 * Math.random() ;

				temp.rotation = ( Math.random() * 360 ) / 180 * Math.PI ;
			}
			_iconNumber = _.shuffle(_iconNumber);
			_onUpdate.id = window.requestAnimationFrame( _onUpdate ) ;
		}
	}


	AboutStage.img = {
		icon:[
			"/park/2018/assets/common/img/outline/about/01_icon.png",
			"/park/2018/assets/common/img/outline/about/02_icon.png",
			"/park/2018/assets/common/img/outline/about/03_icon.png",
			"/park/2018/assets/common/img/outline/about/04_icon.png",
			"/park/2018/assets/common/img/outline/about/05_icon.png",
			"/park/2018/assets/common/img/outline/about/06_icon.png",
			"/park/2018/assets/common/img/outline/about/07_icon.png",
			"/park/2018/assets/common/img/outline/about/08_icon.png",
			"/park/2018/assets/common/img/outline/about/09_icon.png",
			"/park/2018/assets/common/img/outline/about/10_icon.png",
			"/park/2018/assets/common/img/outline/about/11_icon.png",
			"/park/2018/assets/common/img/outline/about/12_icon.png",
		]
	}

	var sizing = function(canvas,container) {
		canvas.height = container.offsetHeight;
		canvas.width = container.offsetWidth;
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;


	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	document.readyState === "complete"
		? setTimeout( function(){ new Main( ) ; } , 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new Main( ) ; } ) ;


//------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
